import { StockStatuses } from '@dcxwam/dcx-wam-ui-foundations'
import { ProductStockData, StockLevelStatus } from '../../../../services/stock'
import { ProductDataVariant } from '../../../../services/product/product-data'

export type Stocks = {
  [code: ProductStockData['code']]: ProductStockData['stock']
}

export const STOCKS_CACHE_MAX_AGE = 5 * 6e4

export const stockStatusMap: {
  [key in StockLevelStatus | string]: StockStatuses
} = {
  [StockLevelStatus.inStock]: StockStatuses.InStock,
  [StockLevelStatus.lowStock]: StockStatuses.LowStock,
  [StockLevelStatus.outOfStock]: StockStatuses.OutOfStock
}

export const getStockLevelStatus = (
  item?: ProductDataVariant,
  stocks?: Stocks
): string | undefined =>
  (item?.globalArticleCode &&
    stocks?.[item?.globalArticleCode]?.stockLevelStatus) ||
  item?.stock?.stockLevelStatus
